<template>
  <v-dialog
    v-model="openModal"
    fullscreen
    no-click-animation
    persistent
    hide-overlay
    transition="dialog-bottom-transition"
  >
    <v-card name="proposal-card">
      <v-toolbar dark color="primary">
        <v-btn
          icon
          dark
          @click="close()"
          :loading="is_loading"
          :disabled="is_loading"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-toolbar-title>{{ proposalId ? (readonly ? 'Visualizar Proposta' : 'Editar Proposta') : 'Nova Proposta' }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-btn
            v-if="!readonly"
            dark
            text
            @click="saveProposal"
            :loading="is_loading"
            :disabled="is_loading"
          >
            <v-icon left>mdi-content-save</v-icon>
            Salvar
          </v-btn>
        </v-toolbar-items>
      </v-toolbar>
      <div
        name="proposal-container"
        style="padding-bottom: 72px; overflow-y: auto;"
      >
        <Proposal
          ref="proposalComponent"
          :show="true"
          :param="param"
          :desiredProposal="desiredProposal"
          :idLead="idLead"
          :idFranchisee="idFranchisee"
          :proposalId="proposalId"
          :fixedProposalType="fixedProposalType"
          :readonly="readonly"
        />
        <v-overlay v-if="is_loading" absolute>
          <v-progress-circular
            indeterminate
            color="primary"
            :size="50"
          ></v-progress-circular>
        </v-overlay>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import Proposal from "./Proposal.vue";

export default {
  name: "ProposalDialog",
  
  components: {
    Proposal,
  },
  
  props: {
    openModal: {
      type: Boolean,
      default: false,
    },
    idLead: {
      type: String,
      default: null,
    },
    idFranchisee: {
      type: String,
      default: null,
    },
    proposalId: {
      type: String,
      default: null,
    },
    fixedProposalType: {
      type: String,
      default: null,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    param: {
      type: Object,
      default: () => ({}),
    },
    desiredProposal: {
      type: Array,
      default: () => [],
    },
    closeFunc: {
      type: Function,
      default: () => {},
    },
  },
  
  data: () => ({
    is_loading: false,
  }),
  
  methods: {
    close() {
      this.closeFunc();
    },
    async saveProposal() {
      if (this.$refs.proposalComponent) {
        this.is_loading = true;
        try {
          await this.$refs.proposalComponent.saveProposal();
          // Aguardar um pouco antes de fechar para o usuário ver a mensagem de sucesso
          setTimeout(() => {
            this.close();
          }, 1500);
        } catch (error) {
          console.error('Erro ao salvar proposta:', error);
          // O erro já foi exibido pelo componente Proposal
        } finally {
          this.is_loading = false;
        }
      }
    },
  },
};
</script>

<style scoped>
</style>

